import VersusScatterChart from './VersusScatterChart';
import './VersusScatterChart.scss';

export default VersusScatterChart;